const utils = require('frontend-controller/lib/utils')

module.exports = {
    extends: [
        '/',
        'templates',
        'core',
        'form',
        'fields',
        'autoComplete',
    ],

    config: {
        heartbeatRefreshOn: {
            'reconnect': true,
            'resourceChanged.bosch_drivers': true,
        },
    },

    methods: {
        async addNewElement(value){
            let controller
            this.closest('templates_core_controller_controller', c => controller = c)
            if(!controller) {
                return
            }

            // tell the closest controller to show the driver insert form
            const onDecisionProcessedPromise = utils.promise.newCustom(this)
            await controller.showInsert('drivers', 'preventParentEntityForeignKey', undefined, {
                dirtyAttributesForProperties: {
                    name: value,
                },
                onDecisionProcessedPromise
            })

            // wait until user has made up his mind about the new drivers input fields
            const decisionData = await onDecisionProcessedPromise

            // check if the potentially newly created driver may be selected chosen.
            const driverID = ((((((decisionData || {}).processing || {}).submit || {}).response || {}).data || {}).attributes || {}).driverID
            if(!driverID) {
                return
            }

            // usually visible form fields prevent a fresh via resource changes.
            // but this time one would like to select the newly created driver directly after.
            // the heartbeatKey workaround is used to force the refresh.
            // most pickers cache their resources and prevent multiple refreshes afterward, except for some special occasions.
            // just like the server tells them via heartbeat a refresh is necessary.
            await this.refresh(true, { refreshResourcesViaHeartbeatKey: 'resourceChanged.bosch_drivers' })
            this.chooseByRealValue(driverID)
        }
    }
}